import { useState, useMemo } from 'react';
import { casesData } from '@/mocks/cases';
import CasesFilter from './CasesFilter';
import CaseCard from './CaseCard';

export default function CasesList() {
  const [activeCategory, setActiveCategory] = useState('all');

  const filtered = useMemo(() => {
    if (activeCategory === 'all') return casesData;
    return casesData.filter((c) => c.category === activeCategory);
  }, [activeCategory]);

  return (
    <>
      <CasesFilter active={activeCategory} onChange={setActiveCategory} />

      <section className="py-16 md:py-20 bg-[#fafaf8]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10">
          {filtered.length === 0 ? (
            <div className="py-24 text-center text-[#8a8a8a]" style={{ fontSize: '1.1875rem' }}>
              此分類目前尚無案例，歡迎聯絡我們了解更多。
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filtered.map((item, i) => (
                <CaseCard
                  key={item.id}
                  item={item}
                  featured={i === 0 && activeCategory === 'all'}
                />
              ))}
            </div>
          )}

          {/* Stats Bar */}
          <div className="mt-16 pt-12 border-t border-[#e2ddd8] grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { num: '150+', label: '完成案例' },
              { num: '6大類', label: '商業空間類型' },
              { num: '30,000+', label: '規劃坪數（坪）' },
              { num: '12+', label: '年設計經驗' },
            ].map((s) => (
              <div key={s.label}>
                <div
                  className="font-bold text-[#1a1a1a] mb-1"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '2.5rem', lineHeight: 1.1 }}
                >
                  {s.num}
                </div>
                <div className="text-[#8a8a8a] text-sm">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
